import { AddToQueueOutlined } from '@mui/icons-material';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStipoPublicacaoOficialList, TipoPublicacaoOficialList } from '../../../../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';

const loadStateFromLocalStorage = (): PublicacaoOficialListFiltro => {
  const savedState = localStorage.getItem('publicacaoOficialListFiltro');
  if (savedState) {
    try {
      // Tenta fazer o parse do JSON armazenado
      const parsedState: PublicacaoOficialListFiltro = JSON.parse(savedState);

      // Aqui você pode validar ou manipular os dados, se necessário
      return parsedState;
    } catch (error) {
      console.error('Erro ao ler o estado do localStorage:', error);
      // Retorna o valor inicial caso haja algum erro no parsing
      return ISPublicacaoOficialListFiltro;
    }
  }
  // Caso não haja dados no localStorage, define as datas de início e fim
  const currentYear = new Date().getFullYear();
  const dataInicial = `01/01/${currentYear-5}`;
  const dataFinal = `31/12/${currentYear}`;

  return {
    ...ISPublicacaoOficialListFiltro, // Espalha os valores padrão
    dataInicial,
    dataFinal
  };
};

// Função para gravar o estado no localStorage
export const saveStateToLocalStorage = (state: PublicacaoOficialListFiltro) => {
  try {
    // Convertendo as datas para string ISO antes de salvar

    // Converte o estado para uma string JSON e salva no localStorage
    localStorage.setItem('publicacaoOficialListFiltro', JSON.stringify(state));
  } catch (error) {
    console.error('Erro ao gravar no localStorage:', error);
  }
};

interface PublicacaoOficialListFiltro {
  dataInicial: string | null;
  dataFinal: string | null;
  search: string | '';
  apply: boolean;
  exercicio?: string | null;
  tipo: TipoPublicacaoOficialList | null;
}

const ISPublicacaoOficialListFiltro: PublicacaoOficialListFiltro = {
  dataInicial: null,
  dataFinal: null,
  search: '',
  apply: false,
  exercicio: null,
  tipo: IStipoPublicacaoOficialList
};

const publicacaoOficialPublicListFiltroSlice = createSlice({
  name: 'publicacaoOficialPublicListFiltro',
  initialState: loadStateFromLocalStorage,
  reducers: {
    atualizarPublicacaoOficialFiltro: (state, action: PayloadAction<PublicacaoOficialListFiltro>) => {
      state = action.payload;
    },
    atualizarPublicacaoOficialExercicio: (state, action: PayloadAction<string | null>) => {
      state.exercicio = action.payload;
    },
    atualizarPublicacaoOficialTipo: (state, action: PayloadAction<TipoPublicacaoOficialList | null>) => {
      state.tipo = action.payload;
    },
    // Ação para atualizarPublicacaoOficial o campo dataInicial
    atualizarPublicacaoOficialDataInicial: (state, action: PayloadAction<string | null>) => {
      state.dataInicial = action.payload;
    },
    // Ação para atualizarPublicacaoOficial o campo dataFinal
    atualizarPublicacaoOficialDataFinal: (state, action: PayloadAction<string | null>) => {
      state.dataFinal = action.payload;
    },
    atualizarPublicacaoOficialSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    atualizarPublicacaoOficialApply: state => {
      state.apply = !state.apply;
    },

    resetPublicacaoOficial: () => ISPublicacaoOficialListFiltro,

    setPublicacaoOficial: (state, action: PayloadAction<PublicacaoOficialListFiltro>) => {
      return { ...state, ...action.payload }; // Atualiza o estado com os dados recebidos
    },
    setStoragePublicacaoOficial: state => {
      saveStateToLocalStorage(state);
    }
  }
});
// Exportando as ações (reducers)
export const {
  atualizarPublicacaoOficialFiltro,
  atualizarPublicacaoOficialDataInicial,
  atualizarPublicacaoOficialDataFinal,
  atualizarPublicacaoOficialSearch,
  resetPublicacaoOficial,
  setPublicacaoOficial,
  setStoragePublicacaoOficial,
  atualizarPublicacaoOficialApply,
  atualizarPublicacaoOficialExercicio,
  atualizarPublicacaoOficialTipo
} = publicacaoOficialPublicListFiltroSlice.actions;

export default publicacaoOficialPublicListFiltroSlice.reducer;
